(function () {
  'use strict';

  /* ---------- Formatação de preço ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || 'R$ {{amount_with_comma_separator}}';
    function fmt(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount_with_comma_separator';
    var value;
    switch (key) {
      case 'amount': value = fmt(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2, '.', ',');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Slider de depoimentos ---------- */
  function initSliders(root) {
    (root || document).querySelectorAll('[data-zc-slider]').forEach(function (slider) {
      if (slider.dataset.zcReady) return;
      slider.dataset.zcReady = '1';
      var items = slider.querySelectorAll('.zc-reviews-slider__item');
      if (items.length < 2) return;
      var i = 0;
      function go(n) {
        items[i].classList.remove('is-active');
        i = (n + items.length) % items.length;
        items[i].classList.add('is-active');
      }
      var prev = slider.querySelector('[data-zc-prev]');
      var next = slider.querySelector('[data-zc-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      var timer = setInterval(function () { go(i + 1); }, 7000);
      slider.addEventListener('pointerenter', function () { clearInterval(timer); });
    });
  }

  /* ---------- Produto ---------- */
  function initProduct(section) {
    if (section.dataset.zcReady) return;
    section.dataset.zcReady = '1';

    var moneyFormat = section.dataset.moneyFormat;
    var variantsEl = section.querySelector('[data-zc-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var variantInput = section.querySelector('[data-zc-variant-input]');
    var qtyInput = section.querySelector('[data-zc-qty-input]');
    var atc = section.querySelector('[data-zc-atc]');
    var atcLabel = section.querySelector('[data-zc-atc-label]');
    var atcText = atcLabel ? atcLabel.textContent : '';
    var kits = section.querySelectorAll('[data-zc-kits] input[type=radio]');
    var sticky = section.querySelector('[data-zc-sticky]');

    var current = variants.find(function (v) { return variantInput && String(v.id) === variantInput.value; }) || variants[0];

    function selectedKit() {
      var k = section.querySelector('[data-zc-kits] input:checked');
      return k ? { qty: parseInt(k.value, 10), discount: parseInt(k.dataset.discount || '0', 10), title: k.dataset.title } : { qty: 1, discount: 0, title: '' };
    }

    function kitTotals(v, qty, discount) {
      var total = Math.round(v.price * qty * (100 - discount) / 100);
      var base = Math.max(v.compare_at_price || v.price, v.price);
      return { total: total, compare: base * qty, unit: Math.round(total / qty) };
    }

    function render() {
      if (!current) return;
      // preço avulso
      var p = section.querySelector('[data-zc-price]');
      var c = section.querySelector('[data-zc-compare]');
      if (p) p.textContent = formatMoney(current.price, moneyFormat);
      if (c) {
        if (current.compare_at_price > current.price) { c.textContent = formatMoney(current.compare_at_price, moneyFormat); c.hidden = false; }
        else c.hidden = true;
      }
      var pb = section.querySelector('[data-zc-price-block]');
      if (pb) {
        var off = pb.querySelector('[data-zc-off]');
        if (off) {
          if (current.compare_at_price > current.price) { off.hidden = false; off.textContent = Math.floor((current.compare_at_price - current.price) * 100 / current.compare_at_price) + '% OFF'; }
          else off.hidden = true;
        }
        var pix = pb.querySelector('[data-zc-pix]');
        if (pix) pix.textContent = formatMoney(Math.floor(current.price * (100 - parseInt(pb.dataset.pix || '0', 10)) / 100), moneyFormat);
        var inst = pb.querySelector('[data-zc-inst]');
        if (inst) inst.textContent = formatMoney(Math.floor(current.price / Math.max(1, parseInt(pb.dataset.inst || '1', 10))), moneyFormat);
      }
      // kits
      kits.forEach(function (input) {
        var label = input.closest('.zc-kit');
        var t = kitTotals(current, parseInt(input.value, 10), parseInt(input.dataset.discount || '0', 10));
        var tEl = label.querySelector('[data-zc-kit-total]');
        var cEl = label.querySelector('[data-zc-kit-compare]');
        if (tEl) tEl.textContent = formatMoney(t.total, moneyFormat);
        if (cEl) { cEl.textContent = formatMoney(t.compare, moneyFormat); cEl.hidden = t.compare <= t.total; }
        var uEl = label.querySelector('[data-zc-kit-unit]');
        if (uEl) uEl.textContent = formatMoney(t.unit, moneyFormat);
        label.classList.toggle('is-active', input.checked);
      });
      var kit = selectedKit();
      var qtyField = section.querySelector('[data-zc-qty-field]');
      if (!kits.length && qtyField) kit.qty = Math.max(1, parseInt(qtyField.value, 10) || 1);
      if (qtyInput) qtyInput.value = kit.qty;
      // botão
      if (variantInput) {
        variantInput.value = current.id;
        variantInput.disabled = !current.available;
      }
      if (atc) {
        atc.disabled = !current.available;
        if (atcLabel) atcLabel.textContent = current.available ? atcText : (window.variantStrings ? window.variantStrings.soldOut : 'Esgotado');
      }
      // barra fixa
      if (sticky) {
        var t2 = kitTotals(current, kit.qty, kit.discount);
        var kitEl = sticky.querySelector('[data-zc-sticky-kit]');
        if (kitEl) kitEl.textContent = kit.title || (current.title !== 'Default Title' ? current.title : '');
        sticky.querySelector('[data-zc-sticky-unit]').textContent = formatMoney(t2.unit, moneyFormat);
        sticky.querySelector('[data-zc-sticky-total]').textContent = formatMoney(t2.total, moneyFormat);
        sticky.querySelector('[data-zc-sticky-compare]').textContent = t2.compare > t2.total ? formatMoney(t2.compare, moneyFormat) : '';
      }
    }

    kits.forEach(function (input) { input.addEventListener('change', render); });

    // quantidade (sem kits)
    var qtyBox = section.querySelector('[data-zc-qty]');
    if (qtyBox) {
      var field = qtyBox.querySelector('[data-zc-qty-field]');
      qtyBox.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        var v = Math.max(1, (parseInt(field.value, 10) || 1) + (b.hasAttribute('data-zc-qty-plus') ? 1 : -1));
        field.value = v;
        render();
      });
      field.addEventListener('change', render);
    }

    // zoom da galeria
    var lb = section.querySelector('[data-zc-lightbox]');
    if (lb) {
      var lbImg = lb.querySelector('[data-zc-lightbox-img]');
      var zooms = function () { return Array.prototype.slice.call(section.querySelectorAll('[data-zc-zoom]')); };
      var idx = 0;
      var show = function (n) { var z = zooms(); if (!z.length) return; idx = (n + z.length) % z.length; lbImg.src = z[idx].dataset.zcZoom; };
      var close = function () { lb.hidden = true; document.body.classList.remove('overflow-hidden'); };
      section.addEventListener('click', function (e) {
        var it = e.target.closest('[data-zc-zoom]');
        if (!it || window.innerWidth < 750) return;
        show(zooms().indexOf(it)); lb.hidden = false; document.body.classList.add('overflow-hidden');
      });
      section.addEventListener('keydown', function (e) {
        var it = e.target.closest && e.target.closest('[data-zc-zoom]');
        if (it && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); show(zooms().indexOf(it)); lb.hidden = false; }
        if (!lb.hidden && e.key === 'Escape') close();
      });
      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-zc-lightbox-prev]')) return show(idx - 1);
        if (e.target.closest('[data-zc-lightbox-next]')) return show(idx + 1);
        if (e.target.closest('[data-zc-lightbox-close]') || e.target === lb) close();
      });
      document.addEventListener('keydown', function (e) { if (!lb.hidden && e.key === 'Escape') close(); });
    }

    // prazo de entrega em dias úteis
    section.querySelectorAll('[data-zc-delivery]').forEach(function (el) {
      var skip = el.dataset.skipWeekend === 'true';
      function add(days) {
        var d = new Date();
        var n = 0;
        while (n < days) { d.setDate(d.getDate() + 1); if (!skip || (d.getDay() !== 0 && d.getDay() !== 6)) n++; }
        return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2);
      }
      var a = el.querySelector('[data-zc-d1]'), b2 = el.querySelector('[data-zc-d2]');
      if (a) a.textContent = add(parseInt(el.dataset.min, 10));
      if (b2) b2.textContent = add(parseInt(el.dataset.max, 10));
    });

    // contador
    section.querySelectorAll('[data-zc-countdown]').forEach(function (el) {
      var out = el.querySelector('[data-zc-countdown-time]');
      var period = Math.max(1, parseInt(el.dataset.hours, 10) || 24) * 3600000;
      function tick() {
        var now = new Date();
        var start = new Date(now); start.setHours(0, 0, 0, 0);
        var left = period - ((now - start) % period);
        var h = Math.floor(left / 3600000), m = Math.floor(left % 3600000 / 60000), sec = Math.floor(left % 60000 / 1000);
        out.textContent = [h, m, sec].map(function (x) { return ('0' + x).slice(-2); }).join(':');
      }
      tick(); setInterval(tick, 1000);
    });

    // variações
    var groups = section.querySelectorAll('.zc-variant-group');
    groups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.zc-variant-btn');
        if (!btn) return;
        group.querySelectorAll('.zc-variant-btn').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        var lbl = group.querySelector('[data-zc-option-label]');
        if (lbl) lbl.textContent = btn.dataset.value;
        var selected = Array.prototype.map.call(groups, function (g) {
          var a = g.querySelector('.zc-variant-btn.is-active');
          return a ? a.dataset.value : null;
        });
        var match = variants.find(function (v) {
          return v.options.every(function (o, idx) { return o === selected[idx]; });
        });
        if (match) {
          current = match;
          if (match.featured_media) {
            var item = section.querySelector('[data-media-id="' + match.featured_media.id + '"]');
            var gallery = section.querySelector('[data-zc-gallery]');
            if (item && gallery) {
              if (window.innerWidth < 990) gallery.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
              else if (item !== gallery.firstElementChild) gallery.prepend(item);
            }
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
        render();
      });
    });

    // galeria (pontinhos no celular)
    var gallery = section.querySelector('[data-zc-gallery]');
    var dots = section.querySelectorAll('.zc-gallery__dots span');
    if (gallery && dots.length) {
      gallery.addEventListener('scroll', function () {
        var idx = Math.round(gallery.scrollLeft / gallery.clientWidth);
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
      }, { passive: true });
    }

    // barra fixa
    if (sticky && atc) {
      var btn = sticky.querySelector('[data-zc-sticky-btn]');
      btn.addEventListener('click', function () {
        var form = atc.form || atc.closest('form');
        if (form && form.requestSubmit) form.requestSubmit(atc);
        else atc.click();
      });
      if ('IntersectionObserver' in window) {
        var footer = document.querySelector('.zc-footer, footer');
        var atcVisible = true, footerVisible = false;
        function update() {
          var show = !atcVisible && !footerVisible && atc.getBoundingClientRect().top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          btn.tabIndex = show ? 0 : -1;
        }
        new IntersectionObserver(function (entries) { atcVisible = entries[0].isIntersecting; update(); }).observe(atc);
        if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
        var ticking = false;
        window.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var r = atc.getBoundingClientRect();
            atcVisible = r.bottom > 0 && r.top < window.innerHeight;
            update();
            ticking = false;
          });
        }, { passive: true });
      }
    }

    render();
  }

  /* ---------- Carrinho: adicionar recomendação ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-zc-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(btn.dataset.zcUpsellAdd, 10), quantity: 1 }] };
    if (drawer) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) throw new Error(res.description);
        if (drawer && res.sections && !document.getElementById('main-cart-items')) {
          drawer.renderContents({ id: body.items[0].id, sections: res.sections });
        } else if (document.getElementById('main-cart-items')) {
          window.location.reload();
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        if (spinner) spinner.classList.add('hidden');
        var box = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
        if (box) box.textContent = (err && err.message) || (window.cartStrings && window.cartStrings.error) || '';
      });
  });

  /* ---------- Recomendações de produto ---------- */
  if (!customElements.get('zc-recommendations')) {
    customElements.define('zc-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) return;
        this.dataset.loaded = '1';
        var self = this;
        var useFallback = function () {
          var wrap = self.closest('.shopify-section');
          var tpl = wrap && wrap.querySelector('template[data-zc-rec-fallback]');
          if (tpl && !self.querySelector('.zc-fp-grid')) self.appendChild(tpl.content.cloneNode(true));
        };
        if (this.querySelector('.zc-fp-grid')) return;
        fetch(this.dataset.url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var el = doc.querySelector('zc-recommendations');
            if (el && el.querySelector('.zc-fp-grid .zc-tile')) self.innerHTML = el.innerHTML;
            else useFallback();
          })
          .catch(useFallback);
      }
    });
  }

  function initAll(root) {
    initSliders(root);
    (root || document).querySelectorAll('.zc-pdp').forEach(initProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
